import { render, staticRenderFns } from "./Pages.vue?vue&type=template&id=4e6bb376&"
import script from "./Pages.vue?vue&type=script&lang=js&"
export * from "./Pages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e6bb376')) {
      api.createRecord('4e6bb376', component.options)
    } else {
      api.reload('4e6bb376', component.options)
    }
    module.hot.accept("./Pages.vue?vue&type=template&id=4e6bb376&", function () {
      api.rerender('4e6bb376', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pages/Pages.vue"
export default component.exports